module.exports = __webpack_public_path__ + "img/flower-type01.138d456e.png";